import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class CategoryId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): CategoryId {
    if (!(value.length > 0)) {
      throw new Error('内容が入力されていません');
    }
    return new CategoryId(value);
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value;
  }
}
